import { Box, Button, Text } from '@medely/ui-kit';
import { useProNavigate } from '@mp/contexts';
import React from 'react';

export const BackgroundCheckNotCompleted = () => {
  const { navigate } = useProNavigate();

  function handleClickButton() {
    navigate('BackgroundCheckDisclosure');
  }

  return (
    <>
      <Box my={2}>
        <Text size="m">
          Once you have provided your background check information you will be able to use this
          screen to set up direct deposit to receive payment for shifts.
        </Text>
      </Box>
      <Button onClick={handleClickButton} fullWidth>
        Start background check
      </Button>
    </>
  );
};
